import { render } from "./Blocklist.vue?vue&type=template&id=01292830&scoped=true"
import script from "./Blocklist.vue?vue&type=script&lang=js"
export * from "./Blocklist.vue?vue&type=script&lang=js"

import "./Blocklist.vue?vue&type=style&index=0&id=01292830&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01292830"]])

export default __exports__